import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
    CmpsButtonModule,
    CmpsCheckboxModule,
    CmpsDialogModule,
    CmpsIconModule,
    CmpsRadioModule,
} from '@cmps/ng-uikit';

import { ExperimentalNgGridModule } from '../coaching-observation/experimental.grid';
import { CmpsCommonModule } from '../common/common.module';
import { CmpsLazyI18nModule } from '../i18n/i18n.module';

import { TagSetTriggerComponent } from './tags/tag-set-trigger.component';
import { TagsComponent } from './tags/tags.component';

@NgModule({
    imports: [
        CmpsButtonModule,
        CmpsCommonModule,
        CmpsIconModule,
        CmpsLazyI18nModule,
        CommonModule,
        ExperimentalNgGridModule,
        ReactiveFormsModule,
        CmpsDialogModule,
        CmpsRadioModule,
        CmpsCheckboxModule,
    ],
    declarations: [TagsComponent, TagSetTriggerComponent],
    exports: [TagSetTriggerComponent],
})
export class CmpsCoachingTagsModule {}
